window.addEventListener('load', function () {
  const element = document.querySelector('main')
  if (!element || !element.classList.contains('deals_archive')) return

  const parentSelect = document.getElementById('parent_cat')
  const childSelect = document.getElementById('child_cat')
  const conditionSelect = document.getElementById('condition')

  // クエリパラメータから値取得
  const urlParams = new URLSearchParams(window.location.search)
  const parentCat = urlParams.get('parent_cat')
  const childCat = urlParams.get('child_cat')
  const condition = urlParams.get('deals_condition')

  // セレクト復元：親カテゴリ
  if (parentCat) parentSelect.value = parentCat

  // セレクト復元：condition
  if (condition) conditionSelect.value = condition

  // セレクト復元：子カテゴリ（Ajaxで再取得後にセット）
  if (parentCat) {
    fetch(myAjax.ajax_url + '?action=get_child_terms&parent_id=' + parentCat)
      .then((res) => res.json())
      .then((data) => {
        childSelect.innerHTML = '<option value="">選択してください</option>'
        data.forEach((term) => {
          const option = document.createElement('option')
          option.value = term.term_id
          option.textContent = term.name
          childSelect.appendChild(option)
        })
        if (childCat) childSelect.value = childCat // ← ここで再セット
      })
      .catch((error) => {
        console.error('カテゴリの取得に失敗しました', error)
      })
  }

  // 親カテゴリが変更されたとき
  parentSelect.addEventListener('change', function () {
    const parentId = this.value

    fetch(myAjax.ajax_url + '?action=get_child_terms&parent_id=' + parentId)
      .then((res) => res.json())
      .then((data) => {
        childSelect.innerHTML = '<option value="">選択してください</option>'
        data.forEach((term) => {
          const option = document.createElement('option')
          option.value = term.term_id
          option.textContent = term.name
          childSelect.appendChild(option)
        })
      })
      .catch((error) => {
        console.error('カテゴリの取得に失敗しました', error)
      })
  })
})
